// extracted by mini-css-extract-plugin
export var aircallIframe = "_gu-3";
export var fabContainer = "_gu-5";
export var fabRinging = "_gu-6";
export var loadingOverlay = "_gu-4";
export var pulse = "_gu-7";
export var widgetContent = "_gu-2";
export var widgetPanel = "_gu-0";
export var widgetPanelExpanded = "_gu-1";